module.exports = __webpack_public_path__ + "img/slideText.749aa760.jpg";